exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-control-label[data-v-34f5ef54]::after {\n  top: 0.1rem;\n}\n.custom-control-label[data-v-34f5ef54]::before {\n  top: 0.1rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-34f5ef54","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/CheckMark.vue
// module id = OWdZ
// module chunks = 97